import { Stack } from "@mui/material";
import { IDashboardContract } from "../../../../api/hooks/useContracts";
import { ContractDetailItem } from "./ContractDetailItem";
import { getFilteredFieldCells } from "@synota-io/synota-shared-ui";
import { useContractFields } from "../hooks/useContractFields";
import { useAuth } from "../../../../api/auth/useAuth";

export const ContractDetailsList = ({
  contract,
  isLoading,
}: {
  contract: IDashboardContract;
  isLoading?: boolean;
}) => {
  const { isAdmin } = useAuth();
  const cells = getFilteredFieldCells(useContractFields(), contract, "details");

  if (isLoading) {
    return null;
  }

  return (
    <Stack pb={6} pt={4} px={6}>
      {cells.map(([def, value]) => {
        return (
          <ContractDetailItem
            key={def.field}
            title={def.headerName}
            value={value}
            divider={def.divider}
            hideNullable={!isAdmin}
            slotProps={{ title: { flexGrow: 0, minWidth: "230px" } }}
          />
        );
      })}
    </Stack>
  );
};
